import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FieldWrap } from './index';
import { FormError } from '../../interfaces';

const useStyles = createUseStyles({
    checkBox: {
        marginTop: '.2rem',
        marginRight: '.5rem',
        height: '1em'
    },
    label: {
        display: 'flex'
    }
});

interface CheckBoxProps {
    name: string;
    label: string;
    error?: FormError;
    required?: boolean;
    register: (options: object) => any;
    disabled?: boolean;
    checked?: boolean;
    value?: string;
    title?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
    name,
    label,
    error,
    register,
    required = false,
    disabled = false,
    checked,
    value,
    title
}: CheckBoxProps) => {
    const classes = useStyles();

    return (
        <FieldWrap error={error} required={required}>
            <label className={classes.label}>
                <input
                    name={name}
                    className={classes.checkBox}
                    type="checkbox"
                    disabled={disabled}
                    required={required}
                    checked={checked}
                    ref={register({ required })}
                    value={value || label}
                    title={title}
                />
                <span title={title} dangerouslySetInnerHTML={{ __html: label + (required ? '*' : '') }} />
            </label>
        </FieldWrap>
    );
};

export default React.memo(CheckBox);
